import React from 'react'
import Navbar from './Components/Navbar';
import Image from './Components/Image';

import Services from './Components/Services';
import Skills from './Components/Skills';

import Maincert from './Components/Maincert';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Test from './Components/Test';
import Footer from './Components/Footer';





export default function Apps() {
  return (
   <>
     
   
  
     
<Router>
  <Navbar/>
<Routes>
<Route path='/' exact element={<Image/>}/>

<Route path='/skills' exact element={<Skills/>}/>
<Route path='/services' exact element={<Services/>}/>
<Route path='/card' exact element={<Test/>}/>

<Route path='/certification' exact element={<Maincert/>}/>
</Routes>
</Router>

<Footer/>



</>

   
    
  )
}